module.exports = __webpack_public_path__ + "ve.svg?a0d8230b9063dfa5323727f4a3b554c3";